<template>
  <div class="javaTemplate_map">
    <DetailsNav></DetailsNav>
    <div class="banner">
        <div class="banerCont" v-if="bannerInfo" :style="{'background-color': bannerInfo.bannerColor, 'background-image': `url(${bannerInfo.bannerBgImg})`}">
            <div class="cont">
                <div class="leftCont">
                    <div class="logo" v-if="bannerInfo.logo && bannerInfo.logo.length > 0"><img :src="bannerInfo.logo[0].url" height="121px" alt=""></div>
                    <div v-else>
                        <div class="title"><div class="colFont">{{bannerInfo.objectName}}</div></div>
                        <div class="subTitle"><div class="colFont">{{bannerInfo.objectSubtitle}}</div></div>    
                    </div>
                    <div class="desc">
                        <banner-desc :data="strToArr(bannerInfo.objectIntroduction)"></banner-desc>
                    </div>
                    <!-- <div class="actionCont" >点击体验 <span v-if="acttionInfo.actionImg && acttionInfo.actionImg.length > 0"><span class="action" @click="openActionHandle()" v-if="butImg"> 操作说明</span>  <img @click="openActionHandle()" v-if="butImg" src="./img/hp_icon.png" width="17" alt=""></span> </div>   -->
                    <div class="platfromList">
                        <div class="platfromPath" v-for="(item, num) in platformData" :key="num" @mouseover="rwmHover(num)" @mouseout="rwmHover(99)" @click="goDetailPage(item.subtitle)">
                            <img v-if="item.icon && item.icon.length > 0" :src="item.icon[0].url" width="20px" alt=""> {{item.title}}
                            <div :class="{rwm:true, showRwm: showRwm == num}" v-if="item.rwm && item.rwm.length > 0">
                                <img :src="item.rwm[0].url" alt="">
                            </div>
                        </div>
                        <!-- <div class="platfromPath" v-if="platformData" @mouseover="rwmHover(1)" @mouseout="rwmHover(99)">
                            <img v-if="platformData[0].icon" :src="platformData[0].icon[0].url" width="20px" alt=""> {{platformData[0].title}}
                            <div :class="{rwm:true, showRwm: showRwm == 1}" v-if="platformData[0].rwm && platformData[0].rwm.length > 0">
                                <img :src="platformData[0].rwm[0].url" alt="">
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="rightCont">
                    <div class="subjectflowTitle">
                        <div class="divNav">
                            <span @click="() => {$router.push('/')}" class="spanSubject">首页 / </span>
                            <span @click="() => {$router.push('/java')}" class="spanSubject">Java</span>
                            <span class="spanSplit"> / </span>
                            <span class="spanName">{{ bannerInfo.objectName }}</span>
                        </div>
                    </div>
                    <div class="videoBox">
                        <!-- <div class="bg_lt_icon"></div> -->
                        <div class="videoMain">
                            <div class="actLab"><span></span><span></span><span></span></div>
                            <div v-if="videoUrl" class="play"  @click="handleVideo()">
                                <img src="./img/icon_play_real.png" width="45px" height="45px" alt="">
                                <div class="videoDesc">
                                    了解项目特色
                                    <!-- {{bannerInfo.videoDesc}} -->
                                </div>
                            </div>
                            <img v-if="bannerInfo.videoBackground && bannerInfo.videoBackground.length > 0" width="574" :src="bannerInfo.videoBackground[0].url" alt="">
                        </div>
                        <!-- <div class="bg_rit_icon"></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rowBox" v-if="bannerLabItems && bannerLabItems.length > 0">
        <div class="bannerLabItems">
            <div class="labItems" v-for="(item, index) in bannerLabItems" :key="index">
                <div><img v-if="item.icon && item.icon.length" :src="item.icon[0].url" width="20" alt=""></div>
                <div>{{item.lab}}</div>
                <div class="num" v-if="item.num">{{item.num}}</div>
            </div>
        </div>
    </div>
    <div class="applicationMoudle" id="scrollA">
        <div>
            <modelTitl :title="mapDataes.applicationData.title" :subTitle="mapDataes.applicationData.subTitle" :enTag="String(mapDataes.applicationData.desc).toUpperCase()"></modelTitl>
        </div>
        <div class="content">
            <div class="items">
                <div class="item" v-for="(item,index) in mapDataes.applicationData.items" :key="index">
                    <div class="icon"><img :src="item.icon" width="32" alt=""></div>
                    <div class="tit">{{item.title}}</div>
                    <div class="desc">{{item.desc}}</div>
                </div>
            </div>
            <img src="./img/map/bg_apl_01.png" class="bgLm01" width="135" alt="">
            <img src="./img/map/bg_apl_02.png" class="bgLm02" width="230" alt="">
        </div>
    </div>
    <!-- 进阶篇-鹰眼轨迹服务 - start -->
    <div class="mapApiMoudle" :class="{scrollBShow:scrollBShow}" id="scrollB">
        <div>
            <modelTitl :title="mapDataes.mapApiMoudleData.title" :subTitle="mapDataes.mapApiMoudleData.subTitle" :enTag="String(mapDataes.mapApiMoudleData.desc).toUpperCase()"></modelTitl>
        </div>
        <div class="content">
            <div class="itemCont">
                <div class="map"><img src="./img/map/map.png" width="100%" alt=""></div>
                <div class="fontCont">
                    <div class="title">{{mapDataes.mapApiMoudleData.cont.title}}</div>
                    <div class="desc">{{mapDataes.mapApiMoudleData.cont.desc}}</div>
                    <div class="labTit">{{mapDataes.mapApiMoudleData.cont.labelTit}}</div>
                    <div class="labList" v-for="(item, ind) in mapDataes.mapApiMoudleData.cont.labelList" :key="ind">
                        <div><span>{{item.title}}</span>{{item.desc}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 进阶篇-鹰眼轨迹服务 - end -->
    <!-- 进阶篇-鹰眼轨迹服务 - start -->
    <div class="trackServerDate" :class="{scrollCShow:scrollCShow}" id="scrollC">
        <div>
            <modelTitl :title="mapDataes.trackServerDate.title" :subTitle="mapDataes.trackServerDate.subTitle" :enTag="String(mapDataes.trackServerDate.desc).toUpperCase()"></modelTitl>
        </div>
        <div class="topLab">
            <div class="cont">
                <div class="title">{{mapDataes.trackServerDate.topLab.title}}</div>
                <div class="subTitle">{{mapDataes.trackServerDate.topLab.subTitle}}</div>
                <div class="desc">{{mapDataes.trackServerDate.topLab.desc}}</div>
            </div>
        </div>
        <div class="content">
            <div class="infoLeft">
                <div class="topInfo">
                    <div class="title">{{mapDataes.trackServerDate.objectInfo.title}}</div>
                    <div class="desc">{{mapDataes.trackServerDate.objectInfo.desc}}</div>
                    <div class="rwm">
                        <!-- <div class="but">
                            <img :src="mapDataes.trackServerDate.objectInfo.icon" width="23px" alt="">
                            <span>{{mapDataes.trackServerDate.objectInfo.labTitle}}</span>
                            <img class="rwmImg" src="./img/map/img_ewm.png" alt="">
                        </div> -->
                    </div>
                </div>
                <div class="capabilityItems">
                    <div :class="{item: true, act: ind == poneActInd}" v-for="(item, ind) in mapDataes.trackServerDate.objectInfo.capabilityItems"  @mouseover="mouseHandle(item, 'phone', ind)" :key="ind">
                        <div class="title">{{item.title}}</div>
                        <div class="desc" v-for="(it, num) in item.descList" :key="num+ind"><span>{{it.tit}}</span>{{it.desc}}</div>
                    </div>
                </div>
            </div>
            <div class="imgRit">
                <img :src="phoneImage" width="330" alt="">
            </div>
        </div>
    </div>
    <!-- 进阶篇-鹰眼轨迹服务 - end -->
    <!-- 物流项目运行 - start -->
    <div class="logisticsMapData"  id="scrollD">
        <div class="content" :class="{scrollDShow:scrollDShow}">
            <div class="bigImage">
                <div class="img" :style="`background-image:url(${mapImage})`"></div>
            </div>
            <div class="info">
                <div class="title">{{mapDataes.logisticsMapData.title}}</div>
                <div :class="{items: true, act: index == actInd}" v-for="(item, index) in mapDataes.logisticsMapData.items" @mouseover="mouseHandle(item, 'map', index)" :key="index">
                    <div class="tit">{{item.title}}</div>
                    <div class="descList">
                        <div class="desc" v-for="(it,ind) in item.descList" :key="String(ind) + index">
                            <span>{{it.tit}}</span>
                            {{it.des}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 物流项目运行 - end -->
    <!-- 解决方案 -start -->
    <div class="program" id="scrollE"  :style="{'background-color':programData.BgColor, 'background-image':`url(${programData.bgImg.length > 0  ? programData.bgImg[0].url : ''})`}">
        <div class="programCont" v-if="programData" :class="{scrollEShow:scrollEShow}">
            <modelTitl :title="programData.title" :subTitle="programData.subTitle" :enTag="String(programData.desc).toUpperCase()"></modelTitl>
            <div class="continer">
                <div class="cont" >
                    <!-- <div @mouseover="stopScroll()" @mouseout="setScroll()"></div> -->
                    <div class="labCont" >
                        <div :class="{lab:true, act:programState == index}" v-for="(item, index) in programData.AboutImage" @mouseover="checkHandle(index)" :key="index+99">{{item.title}}</div>
                    </div>
                    <div class="scrollCont">
                        <div class="scrollList" :style="programCroll">
                            <div :class="{contInfo:true, showst: programState == index}" v-for="(item, index) in programData.AboutImage" :key="index+8">
                                <div class="textInfo">
                                    <div v-for="(it, ind) in strToArr(item.about)" :key="String(index) + ind">
                                        <div class="tit">{{it.title}}</div>
                                        <div class="desc" v-for="(val, num) in it.content" :key="String(index) + String(ind) + num">
                                            <div v-if="val && val != '' && val.search('-') != -1" style="word-wrap:break-word;white-space:pre-wrap"> 
                                                <span class="destit">{{val.split('-')[0]}}：</span>
                                                <span>{{val.split('-')[1]}}</span>
                                            </div>
                                            <div v-else style="word-wrap:break-word;white-space:pre-wrap">{{val.replace('-', '：')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bigImg">
                                    <img :src="item.image[0].url" width="633" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 解决方案 - end -->
    <!-- 课程大纲 - start -->
    <div class="classList" id="scrollF" >
        <div class="scrollCont" :class="{scrollFShow:scrollFShow}">
            <modelTitl v-if="classInfo" :title="classInfo.classTitle" subTitle="" :enTag="classInfo.classEnTitle"></modelTitl>
            <study-path-widge :data="classData"  ></study-path-widge>
        </div>
    </div>
    <!-- 课程大纲 - end -->
    <!-- 讲师风采 - start -->
    <div class="teacherCont" id="scrollG" :style="{'background-color':teacherInfo.teachBgColor, 'background-image':`url(${teacherInfo.teachBgImg && teacherInfo.teachBgImg.length > 0  ? teacherInfo.teachBgImg[0].url : ''})`}">
        <div class="scrollCont" :class="{scrollGShow:scrollGShow}" v-if="teacherInfo && teacherList">
            <modelTitl :title="teacherInfo.teachModleTitle" subTitle="" :enTag="teacherInfo.TeachEnTitle"></modelTitl>
            <common-techer-display-widge :imgs="teacherList" v-if="teacherList.length>0"></common-techer-display-widge> 
        </div>
    </div>
    <!-- 讲师风采 - end -->
    <img v-if="butImg" :src="butImg" width="100%" alt="">
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
    <div class="javaTemMask" v-show="showActionPop && acttionInfo" >
        <div class="javaTemPop">
            <!-- <div class="title">{{acttionInfo.actionlabel}}</div> -->
            <div class="close" @click="() => showActionPop = false">x</div>
            <div class="infoImg">
                <!-- <img v-if="acttionInfo.actionImg && acttionInfo.actionImg.length > 0" :src="acttionInfo.actionImg[0].url" width="100%" alt=""> -->
                <div class="desc">探索更多功能，请体验项目！</div>
                <div class="goInfo" @click="() => showActionPop = false">
                    <span>开始体验</span>
                </div>
            </div>
        </div>
    </div>
    <RiskWarning ref="RiskWarning" :url="goUrl"></RiskWarning>
  </div>
</template>
<script>
import { javaObject } from "../../../../gqlapi/JavaDetail.js";
import DetailsNav from "../../../components/detailsNav.vue";
import bannerDesc from "../../../components/bannerDesc.vue";
// import Platform from "./components/Platform.vue"
import studyPathWidge from "./components/javaStudyPathWidge";
import commonTecherDisplayWidge from "./components/techerDisplayWidge";
import modelTitl from "./components/modelTitle.vue"
import bottomWidge from "./../../../components/bottomWidge";
import MenuAdd from "./../../../components/video";
import mapDataes from './map.data.js'
import RiskWarning from "../../../components/riskWarning.vue";
export default {
  components: {
    bannerDesc,
    DetailsNav,
    bottomWidge,
    modelTitl,
    studyPathWidge,
    commonTecherDisplayWidge,
    MenuAdd,
    RiskWarning
  },
  data() {
    return {
        topImg: '',
        butImg: '',
        showRwm: 99,
        bannerDeSt:false,
        showActionPop:false,
        platIsOpen: true,
        baseData:null,
        poneActInd: 0,
        bannerInfo: {},
        platformInfo: null,
        platformData: null,
        modelData: [],  // 功能模块、技术架构
        programData: null,  // 解决方案
        classData: null, // 课程大纲
        teacherInfo: null,
        teacherList:null, //讲师列表
        classInfo:null,
        programState: 0,
        actInd: 0,
        scrollState: 'add',
        videoUrl: '',
        acttionInfo: null,
        topImgSt: true,
        objName: '',
        routerLink: '',
        scrollAShow: false,
        scrollBShow: false,
        scrollCShow: false,
        scrollDShow: false,
        scrollEShow: false,
        scrollFShow: false,
        scrollGShow: false,
        mapDataes,
        bannerLabItems:[],
        mapImage:require('./img/map/img_map_route.png'),
        phoneImage:require('./img/map/img_phone_route.png'),
        goUrl: ''
    };
  },
  computed: {
      programCroll:function(){
          return {
              width: this.programData.AboutImage.length * 1180 + 'px',
              left: -this.programState * 1180 + 'px'
          }
      }
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.scrollMoveHandle);
    
  },
  methods: {
      getData() {
        this.$axios.post('/api',{
            operationName: "javaObject",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: javaObject
        })
        .then((res) => {
          const data = this.baseData = res.data.data.javaObject
          this.bannerInfo = {
              logo:data.logo,
              objectName:data.objectName,
              objectSubtitle:data.objectSubtitle,
              objectIntroduction:data.objectIntroduction,
              bannerColor:data.bannerColor,
              videoBackground:data.videoBackground,
              videoDesc:data.videoDesc,
              bannerBgImg: data.bannerImg && data.bannerImg.length > 0 ? data.bannerImg[0].url : ''
          }
          this.bannerLabItems = data.webbannerItems
          this.videoUrl = data.videoUrl
          this.platformData = data.plateform && data.plateform.length > 0 ? data.plateform.filter((it) => it.subtitle) : []
          this.modelData = data.modular
          this.programData = data.program
          this.classInfo = {
              classTitle: data.classTitle,
              classEnTitle: data.classEnTitle
          }
          this.classData = data.classList
          this.teacherInfo = {
              teachModleTitle: data.teachModleTitle,
              TeachEnTitle: data.TeachEnTitle,
              teachBgColor: data.teachBgColor,
              teachBgImg: data.teachBgImg
          }
          this.teacherList = data.teacheres
          this.topImg = data.topImg.length > 0 ? data.topImg[0].url : ''
          this.butImg = data.botImg.length > 0 ? data.botImg[0].url : ''
          this.acttionInfo = {
              actionlabel: data.actionlabel,
              actionImg: data.actionImg
          }
        //   this.scrollHandle()
        });
    },
    mouseHandle(item, key, ind){
        if (key === 'map'){
            this.mapImage = item.bigImage
            this.actInd = ind
        } else {
            this.phoneImage = item.bigImage
            this.poneActInd = ind
        }
    },
    scrollMoveHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 显示马上学习导航
      let tag2 = document.querySelector("#scrollA");
      let tag3 = document.querySelector("#scrollB");
      let tag4 = document.querySelector("#scrollC");
      let tag5 = document.querySelector("#scrollD");
      let tag6 = document.querySelector("#scrollE");
      let tag7 = document.querySelector("#scrollF");
      let tag8 = document.querySelector("#scrollG");
      const num = 750
      if (scrollTop >= tag2.offsetTop - num) {
        this.scrollAShow = true;
      }
      if (scrollTop >= tag3.offsetTop - num) {
        this.scrollBShow = true;
      }
      if (scrollTop >= tag4.offsetTop - num) {
        this.scrollCShow = true;
      }
      if (scrollTop >= tag5.offsetTop - num) {
        this.scrollDShow = true;
      }
      if (scrollTop >= tag6.offsetTop - num) {
        this.scrollEShow = true;
      }
      if (scrollTop >= tag7.offsetTop - num) {
        this.scrollFShow = true;
      }
      if (scrollTop >= tag8.offsetTop - num) {
        this.scrollGShow = true;
      }
    },
    // 鼠标滑过展示二维码
    rwmHover(index) {
        this.showRwm = index
    },
    // 
    goDetailPage(url){
        if (url && /^http/.test(url)){
            //     window.open(url, '_black')
            this.goUrl = url
            this.$refs.RiskWarning.dialogFormV()
        }
    },
    // 点击体验弹窗
    openActionHandle(){
        this.showActionPop = true
    },
    // 解决方案切换
    checkHandle(ind){
        this.programState = ind
    },
    // 解决方案自动滚动
    scrollHandle(){
        if (this.programData){
            const num = this.programData.AboutImage.length-1;
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.programState == num){
                    this.programState = 0;
                } else {
                    this.programState ++;
                }
            }, 3000)
        }
    },
    stopScroll(){
        clearInterval(this.timer)
    },
    setScroll(){
        this.scrollHandle()
    },
    closeTopImg(){
        window.localStorage.setItem('topImgSt','unShow')
        this.topImgSt = false
    },
    handleVideo() {
      this.$trackEvent("视频介绍", "点击", "前端学科");
      let obj = {
        url: this.videoUrl,
      };
      this.$refs.editMenu.dialogFormV(obj);
    }
  },
  beforeDestroy(){
      this.stopScroll()
      window.removeEventListener("scroll", this.scrollMoveHandle);
  }
};
</script>
<style lang="scss" scoped src="./map.scss"></style>>
